import React from 'react';
import { any, arrayOf, func, string } from 'prop-types';
import { Column, Row } from 'simple-flexbox';
import { createUseStyles, useTheme } from 'react-jss';
import CollapsibleContent from 'components/collapsible/CollapsibleContent';
import { useSidebar } from 'hooks/useSidebar';

const useStyles = createUseStyles({
    activeContainer: {
        backgroundColor: ({ theme }) => theme.color.paleBlueTransparent
    },
    container: {
        display: 'flex',
        height: 33,
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: ({ theme }) => theme.color.paleBlueTransparent
        },
        paddingLeft: 25,
        transition: 'all 0.2s ease-in-out'
    },
    leftBar: {
        borderLeft: ({ level }) =>
            level > 1 ? 'none' : `4px solid #FFFFFF`
    },
    title: {
        fontSize: 15,
        lineHeight: '20px',
        letterSpacing: '0.2px',
        color: ({ theme, isActive }) => (isActive ?  'rgb(83 142 221)'/*theme.color.paleBlue*/ :  'rgba(1, 41, 95, 1)'/*theme.color.grayishBlue*/),
        marginLeft: 5
    }
});

//rgba(1, 41, 95, 1)     rgb(131 144 169)

function MenuItemComponent({ children, id, items = [], level = 1, onClick, title, imagen }) {
    const theme = useTheme();
    const isCollapsible = children && children.length > 0;
    const { isExpanded, isActive, onItemClick } = useSidebar({
        isCollapsible,
        item: id,
        items
    });
    const classes = useStyles({ theme, level, isActive });
    const classNameColumn = isActive ? classes.leftBar : '';
    const classNameContainer = [classes.container, isActive && classes.activeContainer].join(' ');
    const iconColor = isActive ? '#2ED28A' : '#44C2FA';
    function onItemClicked(e) {
        if (onClick) {
            onClick(e);
        }
        onItemClick();
    }

    return (
        <Column key={id} className={classNameColumn} >
            <Row vertical='center' onClick={onItemClicked} className={classNameContainer}>
                <img src={imagen} className="icon-menu-sidebar" />
                {/*<Icon fill={iconColor} opacity={!isActive && '1'} />*/}
                <span className={classes.title}><b>{title}</b></span>
            </Row>
            {isCollapsible && (
                <CollapsibleContent expanded={isExpanded}>
                    {children.map((child) => child.type({ ...child.props }))}
                </CollapsibleContent>
            )}
        </Column>
    );
}

MenuItemComponent.defaultProps = {};

MenuItemComponent.propTypes = {
    children: any,
    icon: func,
    id: string,
    onClick: func,
    items: arrayOf(string),
    title: string
};

export default MenuItemComponent;
